export default function InitInputs() {
  document.querySelectorAll('.textbox__input, .textarea__input').forEach(function (el) {
    const formGroup = el.parentElement.parentElement

    if (!!el.value) {
      formGroup.classList.add('form-group--is-active')
    }

    el.addEventListener('blur', function () {
      const input = this.value
      formGroup.classList.remove('form-group--is-active')
      input === ''
        ? formGroup.classList.remove('form-group--is-active')
        : formGroup.classList.add('form-group--is-active')
    })
    el.addEventListener('focus', function () {
      formGroup.classList.add('form-group--is-active')
    })
  })

  document.querySelectorAll('.textarea__input--autogrow').forEach(el => {
    el.addEventListener('input', function (e) {
      const element = e.target
      element.style.height = 'auto'
      element.style.height = (element.scrollHeight) + 'px'
    })
  })
}
